import { useEffect, useState } from "react";

import { EvaChart } from "constants/charts.enums";
import { useChartsContext } from "contexts";

import { useChartEntities } from "hooks/charts";

import { LegendItemModel } from "models";

import { createLegendItem } from "components/charts/utils";

const useSlopeLegendItem = (): LegendItemModel[] => {
  const { id: chartId } = useChartsContext();
  const { quarterSlope, halfSlope, unitSlope, chartType } = useChartEntities(chartId);
  const [items, setItems] = useState<LegendItemModel[]>([]);

  const isUnitSlopeEnabled = unitSlope?.active;
  const isHalfSlopeEnabled = halfSlope?.active;
  const isQuarterSlopeEnabled = quarterSlope?.active;

  const canChartShowsStats = chartType === EvaChart.MaterialBalanceTime;

  useEffect(() => {
    if (!canChartShowsStats) {
      setItems([]);
      return;
    }

    const unitSlopeLegendItem = createLegendItem(
      "Unit Slope",
      true,
      unitSlope.properties.colour
    );

    const halftSlopeLegendItem = createLegendItem(
      "Half Slope",
      true,
      halfSlope.properties.colour
    );

    const quarterSlopeLegendItem = createLegendItem(
      "Quarter Slope",
      true,
      quarterSlope.properties.colour
    );

    const slopes = [];
    if (isUnitSlopeEnabled) {
      slopes.push(unitSlopeLegendItem);
    }
    if (isHalfSlopeEnabled) {
      slopes.push(halftSlopeLegendItem);
    }
    if (isQuarterSlopeEnabled) {
      slopes.push(quarterSlopeLegendItem);
    }
    setItems(slopes);
  }, [
    isUnitSlopeEnabled,
    isHalfSlopeEnabled,
    isQuarterSlopeEnabled,
    canChartShowsStats,
    unitSlope,
    halfSlope,
    quarterSlope
  ]);

  return items;
};

export default useSlopeLegendItem;
